export default __webpack_public_path__ + "static/media/sfp-tnt.939c18cf.svg";